import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getConsent, OPEN_CONSENT_EVENT, saveConsent } from './consent';

// Accept and Reject share one style on purpose: neither choice is nudged.
const choiceClass =
  'flex-1 md:flex-none md:min-w-[130px] bg-white hover:bg-[#E5E5E5] text-black font-heading font-bold text-sm uppercase tracking-wider rounded-none px-6 py-2.5 transition-colors';

export default function ConsentBanner() {
  const [open, setOpen] = useState(() => !getConsent());

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(OPEN_CONSENT_EVENT, show);
    return () => window.removeEventListener(OPEN_CONSENT_EVENT, show);
  }, []);

  if (!open) return null;

  const choose = (choice) => {
    saveConsent(choice);
    setOpen(false);
  };

  return (
    <div
      role="dialog"
      aria-label="Cookie choices"
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-mono-line bg-mono-card"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      data-testid="consent-banner"
    >
      <div className="max-w-5xl mx-auto px-4 md:px-8 py-4 flex flex-col md:flex-row md:items-center gap-4">
        <p className="flex-1 text-mono-mute text-sm font-body leading-relaxed" data-testid="consent-banner-text">
          We use essential cookies to keep you signed in. Nothing optional, such as analytics, runs unless you
          accept.{' '}
          <Link to="/privacy" className="text-white underline hover:text-mono-mute" data-testid="consent-privacy-link">
            Privacy
          </Link>
        </p>
        <div className="flex gap-3">
          <button type="button" onClick={() => choose('rejected')} className={choiceClass} data-testid="consent-reject-btn">
            Reject
          </button>
          <button type="button" onClick={() => choose('accepted')} className={choiceClass} data-testid="consent-accept-btn">
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
